import { Modal } from "react-bootstrap";
import { useState } from "react";
import Button from "../Button";

const convertToHtml = (data) => {
    return <div className="popoverAvoidClickOutside" dangerouslySetInnerHTML={{ __html: data }}></div>
}
export default function ConfirmMessagePopUpModal(props) {
    const {
        content,
        showModal,
        handleClose,
        handleConfirm,
        btnText
    } = props

    const [showPop, setShow] = useState(showModal)
    return (
        <Modal
            size="md sm xs"
            show={showPop}
            keyboard={false}
            dialogClassName="popTimeOut"
            className="z-index-alertMessage"
            backdropClassName="z-index-alertMessage-backdrop"
            key={`ConfirmMessage${showModal}`}
        >
            <div className="popoverAvoidClickOutside">
                <Modal.Body className="popoverAvoidClickOutside">
                    <div className="popoverAvoidClickOutside">
                        {convertToHtml(content)}
                    </div>
                </Modal.Body>
                <Modal.Footer className="popoverAvoidClickOutside">
                    <Button className="popoverAvoidClickOutside" text={btnText ? btnText : "OK"} customColor={`#EB1700`} action={() => { setShow(false); handleConfirm(false) }} />
                    <Button
                        className="popoverAvoidClickOutside"
                        text="Cancel"
                        customColor="#564c47"
                        action={() => { setShow(false); handleClose(false) }}
                    />
                </Modal.Footer>
            </div>
        </Modal>
    )
}